import { styled } from "@mui/material/styles";
import { MenuItem, Stack } from "@mui/material";

export const StyledMenu = styled(Stack, {
  shouldForwardProp: (prop) => !["width"].includes(prop),
})(({ theme, width }) => ({
  position: "absolute",
  marginTop: "65px",
  zIndex: 1000,
  padding: "5px 0px",
  backgroundColor: theme.palette.hubColors.white,
  border: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  boxShadow: "0px 2px 15px rgba(0,0,0,0.1) !important",
  borderRadius: "5px",
  maxHeight: "250px",
  width: `${width}px`,
  overflowY: "auto",
}));

export const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== "color",
})(({ theme, color }) => ({
  "&.MuiTypography-root": {
    color:
      theme.palette.hubColors[color] ||
      color ||
      theme.palette.hubColors.darkGray1,
    fontSize: "10px important",
  },
  svg: {
    color:
      theme.palette.hubColors[color] ||
      color ||
      theme.palette.hubColors.darkGray1,
    width: "15px",
    height: "15px",
  },
}));

export const StyledRenderValue = styled(Stack)({
  margin: "auto",
  position: "absolute",
  left: "15px",
  top: 0,
  bottom: 0,
  height: "min-content"
})